import { INotification, NotificationLevels, NotificationTypes } from '@app/notifications/_components/utils';
import { callAgroApi } from '@services/agroapi';
import { NotificationResponse, NotificationSummaryResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
export const withNotifications = self => ({
  actions: {
    fetchNotifications({
      level,
      page = 1,
      type,
      read = true
    }: {
      level?: NotificationLevels;
      page: number;
      type?: NotificationTypes[NotificationLevels];
      read: boolean;
    }) {
      let queryString = `page=${page.toString()}&read=${read}&organization_id=${self.id}&`;
      if (type) queryString += `type=${type}`;
      if (level) queryString += `level=${level}`;
      return callAgroApi<NotificationResponse[]>(`/notifications?${queryString}`, 'GET').then(({
        data
      }) => data.map(n => Transformers.notification(n)));
    },
    fetchNotificationSummary() {
      return callAgroApi<NotificationSummaryResponse>(`/notifications/summary?organization_id=${self.id}`, 'GET').then(({
        data
      }) => data);
    },
    toggleNotificationRead(notification: INotification) {
      return callAgroApi(`/notifications/${notification.id}`, 'PATCH', {
        read: !notification.isRead
      });
    },
    markAllAsRead({
      level,
      type
    }: {
      level?: NotificationLevels;
      type?: NotificationTypes[NotificationLevels]; // only sending type or level to api, not both
    }) {
      let queryString = `organization_id=${self.id}&`;
      if (type) queryString += `type=${type}`;
      if (level) queryString += `level=${level}`;
      return callAgroApi(`/notifications/mark_all_read?${queryString}`, 'POST');
    }
  }
});